export default __webpack_public_path__ + "static/media/factory__8.60f3fa16.jpg";